import { supabase, applyOrgFilter } from '../supabaseClient'

// Política de retención (manual): purga documentos de jugadores dados de baja o
// inactivos desde hace más de N meses. La prueba de consentimiento se conserva como
// evidencia (no se toca aquí).
const BUCKET = 'jugadores-documentos'
const ESTATUS_RETENIBLES = ['Baja', 'Inactivo']
export const RETENCION_MESES_DEFAULT = 12

const cutoffISO = (meses) => {
  const d = new Date()
  d.setMonth(d.getMonth() - meses)
  return d.toISOString()
}

// Ids de jugadores candidatos a retención (baja/inactivo y sin cambios hace > N meses).
const getCandidatos = async (orgId, meses) => {
  let q = supabase
    .from('jugadores')
    .select('id')
    .eq('deleted', false)
    .in('estatus', ESTATUS_RETENIBLES)
    .lt('updated_at', cutoffISO(meses))
  q = applyOrgFilter(q, orgId)
  const { data, error } = await q
  if (error) throw error
  return (data || []).map((j) => j.id)
}

// Resumen (preview): cuántos jugadores y cuántos documentos se purgarían.
export const getRetencionResumen = async (orgId = null, meses = RETENCION_MESES_DEFAULT) => {
  try {
    const ids = await getCandidatos(orgId, meses)
    if (ids.length === 0) return { data: { jugadores: 0, documentos: 0 }, error: null }
    const { data: docs, error } = await supabase
      .from('jugadores_documentos')
      .select('id')
      .in('jugador_id', ids)
    if (error) throw error
    return { data: { jugadores: ids.length, documentos: (docs || []).length }, error: null }
  } catch (error) {
    console.error('[getRetencionResumen]', error)
    return { data: null, error }
  }
}

// Aplica la retención: borra los archivos de Storage y los registros de documentos.
export const aplicarRetencion = async (orgId = null, meses = RETENCION_MESES_DEFAULT) => {
  try {
    const ids = await getCandidatos(orgId, meses)
    if (ids.length === 0) return { data: { jugadores: 0, documentos: 0 }, error: null }

    const { data: docs, error } = await supabase
      .from('jugadores_documentos')
      .select('id, file_path')
      .in('jugador_id', ids)
    if (error) throw error

    // Borrar archivos de Storage (en lotes).
    const paths = (docs || []).map((d) => d.file_path).filter(Boolean)
    for (let i = 0; i < paths.length; i += 100) {
      await supabase.storage.from(BUCKET).remove(paths.slice(i, i + 100))
    }

    // Borrar los registros (en lotes).
    const docIds = (docs || []).map((d) => d.id)
    for (let i = 0; i < docIds.length; i += 200) {
      const { error: delErr } = await supabase
        .from('jugadores_documentos')
        .delete()
        .in('id', docIds.slice(i, i + 200))
      if (delErr) throw delErr
    }

    return { data: { jugadores: ids.length, documentos: docIds.length }, error: null }
  } catch (error) {
    console.error('[aplicarRetencion]', error)
    return { data: null, error }
  }
}
